module.exports = __webpack_public_path__ + "img/sloat-playstar.8f2dcc5a.jpg";